import { useMemo } from 'react';
import { useMatch } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/utils/use-match/index.tsx';
import { getBoardUrl, getJSMBoardUrl, getUserBoardUrl } from '../../common/url-utils/index.tsx';
import { useBoardAndLocationContext } from '../use-board-and-location-context/index.tsx';
import { useIsJSMBoard } from '../../services/use-is-jsm-board/index.tsx';

export function useBoardUrl(isCMPBoard?: boolean): string {
	const match = useMatch();
	const { project, user } = useBoardAndLocationContext();
	const isJSMBoard = useIsJSMBoard();
	const isReallyCMPBoard = isCMPBoard !== undefined ? isCMPBoard : !project?.simplified;
	const projectKey = match.params.projectKey ?? '';
	const boardId = match.params.boardId ?? '';

	return useMemo(() => {
		if (!projectKey && !boardId) {
			throw new Error('useBoardUrl() can only be used with board URLs');
		}

		if (user) {
			return getUserBoardUrl(user.accountId, boardId);
		}

		if (isJSMBoard) {
			return getJSMBoardUrl(projectKey, boardId);
		}

		return getBoardUrl(projectKey, boardId, isReallyCMPBoard);
	}, [boardId, isJSMBoard, isReallyCMPBoard, projectKey, user]);
}
